import React, { useState, useEffect } from 'react';
import usePageTitle from '../hooks/usePageTitle';
import api from '../services/api';
import './AliensTeam.css';

const AliensCars = () => {
  usePageTitle('Aliens Cars');
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const response = await api.get('/team-members?team_type=cars');
      // Handle different response structures
      const membersData = Array.isArray(response.data) 
        ? response.data 
        : (response.data?.data && Array.isArray(response.data.data) 
          ? response.data.data 
          : []);
      
      setMembers(membersData.sort((a, b) => (a.order || 0) - (b.order || 0)));
    } catch (error) {
      console.error('Error fetching team members:', error);
      // Set empty array on error - no dummy data
      setMembers([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="aliens-team-container">
        <div className="loading-spinner"></div>
        <p className="loading-text">Loading team members...</p>
      </div>
    );
  }

  return (
    <div className="aliens-team-container">
      <div className="team-header">
        <h1>👽 ALIENS CARS</h1>
        <p className="team-subtitle">Meet our amazing cars team</p>
      </div>

      {members.length === 0 ? (
        <div className="no-team-members">
          <p>No team members found.</p>
        </div>
      ) : (
        <div className="team-members-grid-display">
          {members.map((member) => (
            <div key={member.id} className="team-member-card-display">
              <div className="member-photo-container">
                <img
                  src={member.photo_arabic_url || (member.photo_arabic_path ? `https://aliensteam.com/storage/${member.photo_arabic_path}` : 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="400"%3E%3Crect width="300" height="400" fill="%230a0e27"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23ff00ff" font-family="Arial" font-size="14"%3EPhoto+Arabic%3C/text%3E%3C/svg%3E')}
                  alt={member.name_arabic}
                  className="member-photo"
                  onError={(e) => {
                    // Prevent infinite loop - only set placeholder once
                    if (!e.target.src.includes('data:image/svg+xml')) {
                      e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="400"%3E%3Crect width="300" height="400" fill="%230a0e27"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23ff00ff" font-family="Arial" font-size="14"%3EPhoto+Arabic%3C/text%3E%3C/svg%3E';
                    }
                  }}
                />
              </div>
              <div className="member-info">
                <h3 className="member-name">{member.name}</h3>
                <p className="member-name-arabic">{member.name_arabic}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AliensCars;



